import Loader from "components/loader/Loader";
import React, { useState, useEffect } from "react";
import { MdPerson } from "react-icons/md";
import { toast } from "react-toastify";
import { adminApiService } from "services/api";

const AllUsers = () => {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchUsers = async () => {
    setIsLoading(true);
    try {

      const response = await adminApiService.getTotalUsers();
      if (!response.ok) throw new Error("Failed to fetch users.");
      const data = await response.json();
      setUsers(data.allUsers || []);
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error("Error fetching users.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div className="space-y-6 p-6">
      <div className="rounded-lg bg-white p-6 shadow-sm">
        <div className="overflow-x-auto">
          <div className="mb-5 flex items-center justify-between">
            <h2 className="text-xl font-semibold text-gray-800">All Users</h2>
          </div>
          <table className="w-full table-auto border-collapse">
            <thead>
              <tr className="bg-gray-50 text-left">
                <th className="whitespace-nowrap rounded-tl-lg px-6 py-3 text-xs font-medium uppercase text-gray-700">
                  User
                </th>
                <th className="whitespace-nowrap px-6 py-3 text-xs font-medium uppercase text-gray-700">
                  Email
                </th>
                <th className="whitespace-nowrap px-6 py-3 text-xs font-medium uppercase text-gray-700">
                  Phone
                </th>
                <th className="whitespace-nowrap px-6 py-3 text-xs font-medium uppercase text-gray-700">
                  User Type
                </th>
                <th className="whitespace-nowrap px-6 py-3 text-xs font-medium uppercase text-gray-700">
                  Status
                </th>
                <th className="whitespace-nowrap px-6 py-3 text-xs font-medium uppercase text-gray-700">
                  Creation Method
                </th>
                <th className="whitespace-nowrap rounded-tr-lg px-6 py-3 text-xs font-medium uppercase text-gray-700">
                  Joined Date
                </th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td
                    colSpan="7"
                    className="px-6 py-4 text-center text-gray-500"
                  >
                    <Loader />
                  </td>
                </tr>
              ) : users.length === 0 ? (
                <tr>
                  <td
                    colSpan="7"
                    className="px-6 py-4 text-center text-gray-500"
                  >
                    No users found
                  </td>
                </tr>
              ) : (
                users.map((user) => (
                  <tr key={user.user_id} className="hover:bg-gray-50">
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-3">
                        <div className="flex h-8 w-8 items-center justify-center rounded-md bg-primary/10">
                          <MdPerson className="text-lg text-primary" />
                        </div>
                        <span className="font-medium text-gray-900">
                          {user.first_name} {user.last_name}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-gray-600">{user.email}</td>
                    <td className="px-6 py-4 text-gray-600">
                      {user.phone || "N/A"}
                    </td>
                    <td className="px-6 py-4">
                      <span className="rounded-full bg-primary/10 px-3 py-1 text-xs font-medium text-primary">
                        {user.user_type}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <span
                        className={`rounded-full px-3 py-1 text-xs font-medium ${
                          user.status === "approved"
                            ? "bg-green-100 text-green-600"
                            : "bg-red-100 text-red-600"
                        }`}
                      >
                        {user.status}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <span
                        className={`rounded-full px-3 py-1 text-xs font-medium ${
                          user.directorder
                            ? "bg-blue-100 text-blue-600"
                            : "bg-purple-100 text-purple-600"
                        }`}
                      >
                        {user.directorder ? "Direct Order" : "Register"}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-gray-600">
                      {new Date(user.created_at).toLocaleDateString()}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AllUsers;
